import React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';

import Home from './pages/home';
import Options from './pages/options';
import Renew from './pages/renew';
import Certificates from './pages/certificates';
import Systems from './pages/systems';
import A1 from './pages/a1';
import A3 from './pages/a3';
import Support from './pages/support';
import Tutorial from './pages/tutorial';
import TutorialA3 from './pages/tutorial03';

export default function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/options" component={Options} />
        <Route path="/renew" component={Renew} />
        <Route path="/certificates" component={Certificates} />
        <Route path="/systems" component={Systems} />
        <Route path="/a1" component={A1} />
        <Route path="/a3" component={A3} />
        <Route path="/support" component={Support} />
        <Route path="/tutorial" component={Tutorial} />
        <Route path="/tutoriala3" component={TutorialA3} />
      </Switch>
    </BrowserRouter>
  );
}
